import React from 'react';
import Image from '../assets/img/image.jpg';
import resume from '../assets/resume.pdf';

const About = () => {
    return (
        <section className="about section" id="about">
            <h2 className="section__title">About Me</h2>
            <span className="section__subtitle">Let's know more</span>

            <div className="about__container container grid" id='about-con'>
                <img src={Image} alt="shafnas-about-img" className="about__image" />

                <div className="about__data">
                    <p className="about__description">I am software engineer who has been working in the field for nearly two years. I'm passionate about creating quality products that meet the customer requirements. and I love learning new technologies as I am a visual learner, I usually learn new technologies by doing personal projects. and My strength is I can learn the new things in a short period of time.</p>

                    <div className="about__info">
                        <div>
                            <span className="about__info-title">2+</span>
                            <span className="about__info-name">Years <br/> experience</span>
                        </div>
                        <div>
                            <span className="about__info-title">7+</span>
                            <span className="about__info-name">Worked on <br/> projects</span>
                        </div>
                        <div>
                            <span className="about__info-title">2+</span>
                            <span className="about__info-name">Companies <br/> worked</span>
                        </div>
                    </div>

                    <div className="about__buttons">
                        <a href={resume} className="button button__flex" download="shafnas-cv">
                            Download CV<i className="uil uil-download-alt button__icon"></i>
                        </a>
                    </div>

                </div>
            </div>
        </section>
    )
}

export default About;